/**
 * Obsidian Web Clipper — save web pages into an Obsidian vault
 *
 * A single WAR entry exposes seven files — `reader-script.js`, `side-panel.html`,
 * `highlighter.css`, `reader.css`, `style.css`, `browser-polyfill.min.js` and
 * `flatten-shadow-dom.js` — to every origin with no use_dynamic_url, so each is fetchable
 * from any page at a fixed URL. The reader/highlighter files are vendor-specific to the
 * clipper, so a single fetch is conclusive.
 *
 * Manifest verified against version 1.7.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cnjifjpddelmedmihgijeibhnjfabmlf';

export const obsidianWebClipper: ExtensionDefinition = {
  id: ID,
  name: 'Obsidian Web Clipper',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'Seven static WAR on every origin with no dynamic URL. The reader/highlighter and ' +
    'side-panel paths are conclusive with a single fetch.',
  signals: [
    {
      id: 'war-reader-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch reader-script.js — the reader-mode content script exposed to every origin, ' +
        'distinctive to the clipper.',
      weight: 1,
      run: () => probeFetch(ID, 'reader-script.js'),
    },
    {
      id: 'war-side-panel-html',
      kind: 'web-accessible-resource',
      description: 'Fetch side-panel.html — the clipper panel UI, a second static path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'side-panel.html'),
    },
    {
      id: 'war-highlighter-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch highlighter.css — the highlighter stylesheet, independent of the JS and ' +
        'HTML paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'highlighter.css'),
    },
  ],
};
